export default "__VITE_ASSET__DPxPaeUg__"